import RelayQueryResponseCache from "relay-runtime/lib/RelayQueryResponseCache";
import { Auth } from "aws-amplify";
import { storeError } from "./uncatchableErrorStore";
import { emitCustomEvent } from 'react-custom-events';
import { EVENT_CODES } from 'constants/index';

const { Environment, Network, RecordSource, Store } = require("relay-runtime");

let users = {
  "dev": "userid___1688612088738358931",
  "qa": "userid___1688612088738358931",
  "stg": "userid___1690752509700806004",
  "production": "userid___1690752509700806004"
}

async function get_myhyly_token(operation) {
  if (operation === "getOmichannelPreviewsQuery" ||operation === "getEnrollmentQuery")
    return ""
  if (window.location.hostname === "localhost") {
    return "userid___1709542253522009420"
  }

  const user = await Auth.currentAuthenticatedUser();
  return user.signInUserSession.idToken.jwtToken;
}

const cache = new RelayQueryResponseCache({
  size: 250,
  ttl: 60 * 5 * 1000,
});

const store = new Store(new RecordSource());

const network = Network.create(async (operation, variables) => {
  const token = await get_myhyly_token(operation.name); ///

  let queryId = operation.name;

  let cacheResponse = cache.get(queryId, variables);

  if (cacheResponse) return cacheResponse;
  const response = await fetch(process.env.REACT_APP_MyhylyEndpoint, { // TODO: should hide the endpoint URL
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      query: operation.text,
      variables,
    }),
  });


  const data = await response.json();
  if ((response.status === 401) && (operation.name === "getOrgQuery" || operation.name === "NavDrawerQuery" || operation.name === "initialValuesQueryQuery")) {
    emitCustomEvent(EVENT_CODES.UNAUTH_USER)
  }



  if ((response.status !== 401) && data && data.data && (operation.name === "getOrgQuery" || operation.name === "initialValuesQueryQuery")) {
    console.log("window", window.location)
    let authorizedOrgs = data.data.authorizedOrgs;
    let ids = window.location.pathname.split("/");
    let propertyId = "";
    if (ids.length > 1) {
      propertyId = ids[1]
    }
    let find = false;
    if (propertyId.length > 10) {
      let subOrgs = authorizedOrgs.map(e => {
        e.suborgs && e.suborgs.map(s => {
          if (s.id === propertyId) {
            find = true;
          }
        })
      })
      console.log("find", find, propertyId)
      if (!find) {
        emitCustomEvent(EVENT_CODES.UNAUTH_USER)
      }
    }
  }

  storeError(queryId, data.errors, response, variables)

  if (operation.operationKind === "mutation") {
    cache.clear();
  }
  return data;
});

const environment = new Environment({
  network,
  store,
});

export default environment;
